import { Box, Button, FlexBox } from '@dixa/lib-shared-habla';
import { HookFormTextarea } from 'lib-shared-hook-form';
import { KeyboardEvent } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

type MimSidekickComposerProps = {
  disabled: boolean;
  onSend: (text: string) => void;
};

type FormValues = {
  prompt: string;
};

export const MimSidekickComposer = ({
  disabled,
  onSend,
}: MimSidekickComposerProps): JSX.Element => {
  const { control, handleSubmit, setValue, watch } = useForm<FormValues>({
    mode: 'all',
    defaultValues: {
      prompt: '',
    },
  });

  const prompt = watch('prompt');

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleValidSubmit({ prompt });
    }
  };

  const handleValidSubmit: SubmitHandler<FormValues> = (values) => {
    const { prompt } = values;

    const trimmed = prompt.trim();
    if (!trimmed || disabled) return;

    onSend(prompt.trim());
    setValue('prompt', '');
  };

  return (
    <FlexBox flexDirection="column" gap="200" padding="300">
      <Box flex="1">
        <HookFormTextarea
          name="prompt"
          control={control}
          disabled={disabled}
          componentProps={{
            placeholder: 'Ask anything...',
            autoGrow: true,
            onKeyDown: handleKeyDown,
          }}
          noLabel
        />
      </Box>
      <FlexBox justifyContent="flex-end">
        <Button
          variant="primary"
          type="button"
          onClick={handleSubmit(handleValidSubmit)}
          disabled={disabled || prompt.trim().length === 0}
        >
          Send
        </Button>
      </FlexBox>
    </FlexBox>
  );
};
